var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5BoxIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50.199,
    viewBox: "0 0 50 50.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social-care",
    transform: "translate(-1.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3330",
    "data-name": "Group 3330",
    transform: "translate(1.016 27.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3329",
    "data-name": "Group 3329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3328",
    "data-name": "Group 3328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22338",
    "data-name": "Path 22338",
    d: "M12.918,299.519H2.095a1.076,1.076,0,0,1-1.079-1.073V289.52a1.071,1.071,0,0,1,.416-.847l8.99-6.958A11.133,11.133,0,0,1,17.2,279.4H31.89a4.063,4.063,0,0,1,4.069,4.049,4.011,4.011,0,0,1-.279,1.475l.059-.05,8.268-7.278a4.354,4.354,0,0,1,5.86.178h0a3.89,3.89,0,0,1-.153,5.664L38.87,293.126a9.065,9.065,0,0,1-6.048,2.305H19.108l-5.57,3.893A1.082,1.082,0,0,1,12.918,299.519Zm-9.745-2.146h9.4l5.57-3.893a1.082,1.082,0,0,1,.62-.195H32.822a6.905,6.905,0,0,0,4.607-1.756l10.844-9.689a1.751,1.751,0,0,0,.069-2.549h0a2.186,2.186,0,0,0-2.906-.088l-8.268,7.278a4.077,4.077,0,0,1-2.7,1.016H21.6a1.073,1.073,0,1,1,0-2.146H31.89a1.9,1.9,0,1,0,0-3.8H17.2a8.96,8.96,0,0,0-5.457,1.863l-8.573,6.635v7.328Z",
    transform: "translate(-1.016 -276.548)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_22339",
    "data-name": "Path 22339",
    d: "M158.419,11.895a6.652,6.652,0,1,0-8.175,0,10.847,10.847,0,0,0-6.9,10.093v1.4a1.073,1.073,0,0,0,1.073,1.073H164.25a1.073,1.073,0,0,0,1.073-1.073v-1.4A10.847,10.847,0,0,0,158.419,11.895Zm-4.088-9.748a4.506,4.506,0,1,1-4.506,4.506A4.511,4.511,0,0,1,154.332,2.146Zm8.845,20.17h-17.69a8.847,8.847,0,1,1,17.69,0Z",
    transform: "translate(-128.315)",
    fill: "#61ce65"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5BoxIcon1);
export default __webpack_public_path__ + "static/media/5-box-icon-1.85cd348665c004c92c092daed2b30e5e.svg";
export { ForwardRef as ReactComponent };